import { DownloadIcon } from 'lucide-react'
import { match } from 'ts-pattern'
import { Button } from './Button'

interface IProps {
    source: string
    ext: string
}

const imgExts = [
    'png',
    'jpg',
    'jpeg',
    'gif',
    'bmp',
    'svg',
    'webp',
    'ico',
    'apng',
] as const
const pdfExts = ['pdf'] as const
const textExts = ['txt'] as const
const docExts = [
    'doc',
    'docx',
    'odt',
    'xls',
    'xlsx',
    'ods',
    'ppt',
    'pptx',
    'odp',
] as const
const videoExts = ['mp4', 'webm', 'mkv'] as const

export function isImage(ext: string) {
    return imgExts.includes(ext as (typeof imgExts)[number])
}

export default function PreviewAnexo({ source, ext }: IProps) {
    return match(ext)
        .with(...imgExts, () => (
            <img
                src={source}
                alt={String(source)}
                style={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '100%',
                }}
                loading="lazy"
            />
        ))
        .with(...pdfExts, () => (
            <embed
                src={source}
                type="application/pdf"
                style={{
                    width: '100%',
                    height: 'auto',
                    aspectRatio: '5/4',
                    maxHeight: '100%',
                }}
            />
        ))
        .with(...textExts, () => (
            <iframe
                src={source}
                style={{
                    width: '100%',
                    height: 'auto',
                    aspectRatio: '16/10',
                    maxHeight: '100%',
                }}
            />
        ))
        .with(...docExts, () => (
            <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                    source,
                )}`}
                loading="lazy"
                style={{
                    width: '100%',
                    height: 'auto',
                    aspectRatio: '4/3',
                    maxHeight: '100%',
                }}
            />
        ))
        .with(...videoExts, () => (
            <video
                controls
                autoPlay={false}
                style={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '100%',
                }}
            >
                <source src={source} type="video/mp4" />
            </video>
        ))
        .otherwise(() => (
            <div className="flex flex-col items-center gap-4 w-full h-auto max-h-full">
                <span className="text-base">
                    Tipo de arquivo não suportado para visualização
                </span>
                <Button
                    href={source}
                    rel="external"
                    startIcon={<DownloadIcon />}
                >
                    Baixar
                </Button>
            </div>
        ))
}
